import { useSyncExternalStore } from 'react'
import { subscribeRateLimit, getRateLimitedUntil } from '../github'

export function RateLimitBanner() {
  const resetAt = useSyncExternalStore(subscribeRateLimit, getRateLimitedUntil, () => null)
  if (!resetAt) return null

  return (
    <div
      data-testid="rate-limit-banner"
      role="alert"
      className="bg-amber-500 text-zinc-950 px-6 py-2 text-center text-sm font-bold"
    >
      GitHub rate limit alcanzado. Se restablece a las {resetAt.toLocaleTimeString('es-CL')}.
    </div>
  )
}
